import type { FC } from "react";
import { Container } from "app/components/React/TableTopOverview/TableTopOverviewStyledComponents";
import type { ITableTopOverviewProps } from "app/components/React/TableTopOverview/TableTopOverviewTypes";
import { TableTopOverviewItem } from "app/components/React/TableTopOverview/TableTopOverviewItem";

export const TableTopOverview: FC<ITableTopOverviewProps> = ({
    items,
    isDashboard,
    containerAttributes = {},
    isLoading,
}) => {
    const itemComponents = items.map((itemProps, index) => {
        return (
            <TableTopOverviewItem
                key={`table_top_item_${index}`}
                {...itemProps}
                isLoading={isLoading}
            />
        );
    });

    return (
        <Container
            dashboard={isDashboard}
            {...containerAttributes}
        >
            {...itemComponents}
        </Container>
    );
};
